var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar294480(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 744.09 1052.4",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-38.571 2.8571)",
    fill: "#e6e6e6",
    stroke: "#000",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "m521.38 590.85c0 68.202-65.694 91.953-124.18 90.247-65.473-1.9095-121.16-36.587-111.82-108.35 7.9616-61.098 56.452-130.71 124.86-126.29 69.882 4.5294 111.12 81.164 111.12 144.39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m484.64 389.36c0 100.22-160.87 100.22-160.87 0 0-100.23 160.87-100.22 160.87 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar294480);
export default __webpack_public_path__ + "static/media/avatar-294480.f7fcfa245dbac79fd74786a79c0e0303.svg";
export { ForwardRef as ReactComponent };